module.exports = __webpack_public_path__ + "img/compass-app-img.656dfd0c.jpg";